import { useState, useEffect } from "react";
import { Input, Select } from "antd";
import { InfoIcon } from "../../Icons";
import TextArea from "antd/es/input/TextArea";

import "../../stylesNewPromotion.css";
import "./stylesIOSNotificationForm.css";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

const IOSNotificationForm = ({ setNotificationData }) => {
  const [title, setTitle] = useState(
    "Pay 1 - Get X2. Get +100% on your Rebet Cash Bundle!"
  );
  const [message, setMessage] = useState(
    "Unlock Savings on Rebet Cash Purchase!"
  );
  const [action, setAction] = useState("");

  useEffect(() => {
    setNotificationData((prev) => ({
      ...prev,
      title,
      description: message,
      action,
    }));
  }, [title, message, action, setNotificationData]);

  return (
    <section className="formSection ios-notification">
      <header className="formHeader">
        <h2 className="formTitle">{AppStrings.NOTIFICATION}</h2>
        <button className="infoButton" aria-label={AppStrings.PAM_NEW_PROMOTION_INFO_ARIA}>
          <InfoIcon />
        </button>
      </header>

      <div className="formContent">
        <div className="formGroup">
          <div className="labelRow">
            <label className="inputLabel">{AppStrings.NOTIFICATION_TITLE}</label>
            <span className="highlightText">{AppStrings.HIGHLIGHT_TEXT}</span>
          </div>
          <div className="inputWrapper">
            <Input
              type="text"
              className="textInput"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={100}
            />
            <span className="charCount">{title.length}/100</span>
          </div>
        </div>

        <div className="formGroup">
          <label className="inputLabel">{AppStrings.NOTIFICATION_MESSAGE}</label>
          <div className="inputWrapper">
            <TextArea
              className="textInput"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              autoSize={{ minRows: 3, maxRows: 5 }}
              maxLength={500}
              style={{ resize: "none" }} // impede redimensionamento
            />
            <span className="charCount">{message.length}/500</span>
          </div>
        </div>

        <div className="formGroup">
          <div className="labelRow">
            <label className="inputLabel">{AppStrings.CALL_TO_ACTION}</label>
          </div>
          <Select
            value={action || AppStrings.SELECT_ACTION}
            options={[
              { value: "action1", label: AppStrings.ACTION_1 },
              { value: "action2", label: AppStrings.ACTION_2 },
              { value: "action3", label: AppStrings.ACTION_3 },
            ]}
            onChange={(value) => setAction(value)}
          />
        </div>
      </div>
    </section>
  );
};

export default IOSNotificationForm;
